export function exportToCSV<T>(data: T[], filename: string): void {
  const csvRows = [];

  const headers = Object.keys(data[0] as object);

  csvRows.push(headers.join(";"));

  data.forEach((row) => {
    const values = headers.map((header) => {
      const value = row[header as keyof T];
      return `"${value}"`;
    });
    csvRows.push(values.join(";"));
  });

  const csvContent =
    "data:text/csv;charset=utf-8," + encodeURIComponent(csvRows.join("\n"));

  const link = document.createElement("a");
  link.setAttribute("href", csvContent);
  link.setAttribute("download", filename);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
